import {
  contentGridSx,
  heroDescriptionSx,
  heroTitleSx,
  leftContentSx,
  rightContentSx,
  sectionSx,
} from '@/styles/tour-type-content-styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

type TourTypeContent = {
  hero_title?: string;
  hero_description?: string;
};

type TourTypeContentPageProps = {
  content: TourTypeContent | null;
  leftContentHtml: string;
  rightContentHtml: string;
  sectionBackgroundColor?: string;
};

const TourTypeContentPage = ({
  content,
  leftContentHtml,
  rightContentHtml,
  sectionBackgroundColor,
}: TourTypeContentPageProps) => {
  return (
    <Box
      component="section"
      sx={sectionSx}
      style={
        sectionBackgroundColor
          ? { backgroundColor: sectionBackgroundColor }
          : undefined
      }
    >
      <Container maxWidth="lg">
        <Typography variant="h2" sx={heroTitleSx}>
          {content?.hero_title}
        </Typography>

        <Typography variant="h4" sx={heroDescriptionSx}>
          {content?.hero_description}
        </Typography>

        <Box sx={contentGridSx}>
          <Box sx={leftContentSx} dangerouslySetInnerHTML={{ __html: leftContentHtml }} />
          <Box sx={rightContentSx} dangerouslySetInnerHTML={{ __html: rightContentHtml }} />
        </Box>
      </Container>
    </Box>
  );
};

export default TourTypeContentPage;
